export default {
  // Header
  userConfigAndData: 'User configuration and data',

  // Image buttons
  changeProfilePhoto: 'Change Profile Photo',
  selectProfilePhoto: 'Select Profile Photo',
  updatePassword: 'Update Password',

  // Sections
  personalInformation: 'Personal Information',
  personalInformationSubtitle: 'Basic user data',
  contactInformation: 'Contact Information',
  contactInformationSubtitle: 'Contact details',
  platformLanguage: 'Platform Language',
  platformLanguageSubtitle: 'Select the interface language',

  // Personal information fields
  lastName: 'Last Name',
  lastNamePlaceholder: 'Enter last name',
  firstName: 'First Name',
  firstNamePlaceholder: 'Enter first name',
  identifierType: 'Identifier Type',
  identifier: 'Identifier',
  identifierPlaceholder: 'Enter identifier',
  gender: 'Gender',
  birthDate: 'Date of Birth',
  selectDate: 'Select a date',

  // Gender
  male: 'Male',
  female: 'Female',
  other: 'Other',

  // Contact
  email: 'Email',
  emailPlaceholder: 'email@example.com',

  // Languages
  spanish: 'Español',
  english: 'English',

  // Buttons
  saveChanges: 'Save Changes',
  savePassword: 'Save Password',

  // Password modal
  updatePasswordTitle: 'Update Password',
  currentPassword: 'Current Password',
  currentPasswordPlaceholder: 'Enter your current password',
  currentPasswordRequired: 'You must enter your current password.',
  newPassword: 'New Password',
  newPasswordPlaceholder: 'Enter new password',
  newPasswordTooltip: 'It is recommended to use a combination of uppercase, lowercase, numbers and symbols for greater security.',
  confirmPassword: 'Confirm Password',
  confirmPasswordPlaceholder: 'Confirm new password',
  passwordMismatch: 'Passwords do not match.',
  incorrectPassword: 'The current password is incorrect.',

  // Image modal
  selectImageTitle: 'Select Image',

  // Success messages
  profileCreated: 'Profile created.',
  profileUpdated: 'Profile updated.',
  passwordUpdatedSuccess: 'Password updated successfully.',
  languageChangedToSpanish: 'Idioma cambiado a Español',
  languageChangedToEnglish: 'Language changed to English',
  userUpdated: 'User updated.',

  // UseCardView tabs
  profileTab: 'Profile',
  activityTab: 'Activity',

  // UserLogsView
  activityLog: 'Activity Log',
  activityLogSubtitle: 'History of your changes on the platform',
  searchModelPlaceholder: 'Search by model...',

  // StudentCard specific
  completeStudentFile: 'Complete student file',
  studentPersonalInformationSubtitle: 'Basic student data',
  changeImage: 'Change Image',
  rut: 'RUT',
  rutPlaceholder: '12.345.678-9',
  institutionalInformation: 'Institutional Information',
  academicData: 'Academic data',
  entryYear: 'Entry Year',
  selectCorrectYear: 'Select a correct year.',
  incompleteAdmissionProfile: 'Incomplete Admission Profile',
  admissionProfileNotCompleted: 'You have not yet completed your Admission Profile. Complete the required information.',
  completeAdmissionProfile: 'Complete Admission Profile',
}
